module.exports = __webpack_public_path__ + "8be5fcac737496d40ff35dc4a69cf3cb.png";